import React, { useEffect } from 'react'
import cx from 'classnames'
import getUrl from 'front-end-core/core/url'
import { connect } from 'react-redux'
import { setTiledMenuIsLoaded } from 'redux/actions'
import Grid from '@material-ui/core/Grid'
import ArrowForward from '@material-ui/icons/ArrowForward'
import TileButton from 'components/tiled-menu/TileButton'
import { DASHBOARD } from 'constants/controllers'

const AolMenu = ({ aolConfigLoaded, aolConfig, isTiledMenuLoaded, setTiledMenuIsLoaded }) => {
  useEffect(() => {
    if (aolConfigLoaded) {
      setTiledMenuIsLoaded(true)
    }
  }, [aolConfigLoaded])

  useEffect(() => {
    return () => setTiledMenuIsLoaded(false)
  }, [])

  const tiles = Object.keys(aolConfig).reduce((acc, curr) => {
    const { name, sections, urlFragment } = aolConfig[curr]
    if (!name.length) {
      return acc
    }

    return [...acc, { name, sections, urlFragment }]
  }, [])

  return (
    <div className={cx('layout-width-constraint pta pa7', { dn: !isTiledMenuLoaded })}>
      <Grid container spacing={2}>
        {tiles.map((tile, index) => (
          <Grid key={index} item xs={12} sm={4} md={3} lg={2}>
            <div className='h7 bg-white bb-thick relative'>
              <TileButton
                component='a'
                href={getUrl(DASHBOARD, { aol: tile.urlFragment })}
                disableRipple
                className='h-100 w-100'
              >
                <div className='black no-underline f5 absolute top5 left5 mr4 lh-title'>
                  {tile.name}
                </div>
                <ArrowForward className={cx('absolute bottom4 right6')} />
              </TileButton>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

const mapStateToProps = (state) => ({
  aolConfig: state.aol.aolConfigMap,
  aolConfigLoaded: state.aol.aolConfigLoaded,
  isTiledMenuLoaded: state.placeholders.isTiledMenuLoaded
})

const mapDispatchToProps = dispatch => ({
  setTiledMenuIsLoaded: isLoaded => dispatch(setTiledMenuIsLoaded(isLoaded))
})

export default connect(mapStateToProps, mapDispatchToProps)(AolMenu)
